<template>
	<!-- 项目合同 -->
	<div>
		<div>
			<div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">项目合同</div>
			<el-row style="margin-top: 9px;">
				<div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px; border: 1px solid #eaebed;">
					<el-row>

						<!-- 右侧列表 -->
						<el-col :span="24">
							<el-row style="padding-left: 2%; padding-top: 40px;">
								<el-col :span="5">
									<span>合同名称 </span>
									<el-input v-model="condition.contract_name" placeholder="请输入内容"
										style="width:180px;margin-left:10px"></el-input>
								</el-col>

								<el-col :span="6">
									<el-button type="goon" @click="Find">查询</el-button>
									<el-button type="goon" @click="AddFrom">新增</el-button>
								</el-col>
							</el-row>

							<!-- 表格 -->
							<div style="margin:30px 3% 0 3%">
								<el-row>
									<el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}" height="574px"
										:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData"
										tooltip-effect="dark" style="width: 100%"
										@selection-change="handleSelectionChange">
										<el-table-column type="selection" width="55">
										</el-table-column>
										<el-table-column label="序号" width="80">
											<template slot-scope="scope_1">
												{{scope_1.$index + 1}}
											</template>
										</el-table-column>
										<el-table-column prop="contract_code" align="center" label="合同编码">
										</el-table-column>
										<!-- <el-table-column prop="entry_name" align="center" label="项目名称">
										</el-table-column> -->
										<el-table-column prop="contract_name" align="center" label="合同名称">
										</el-table-column>
										<el-table-column prop="series" align="center" label="系列">
										</el-table-column>
										<el-table-column prop="industry_andInnovation" align="center" label="业务板块">
										</el-table-column>
										<el-table-column prop="first_party" align="center" label="甲方">
										</el-table-column>
										<el-table-column prop="second_party" align="center" label="乙方">
										</el-table-column>
										<el-table-column prop="time_on" align="center" label="开始时间" width="120">
										</el-table-column>
										<el-table-column prop="time_end" align="center" label="结束时间" width="120">
										</el-table-column>
										<el-table-column prop="unit_price" align="center" label="单价">
										</el-table-column>
										<el-table-column prop="number" align="center" label="数量">
										</el-table-column>
										<el-table-column prop="monthly_total" align="center" label="月合计">
										</el-table-column>
										<el-table-column prop="annual_total" align="center" label="年合计">
										</el-table-column>
										<el-table-column prop="page_number" align="center" label="页码数">
										</el-table-column>
										<el-table-column prop="contractual_accounting_period" align="center"
											label="合同约定账期" width="150">
										</el-table-column>
										<el-table-column prop="performance_bond" align="center" label="履约金">
										</el-table-column>
										<el-table-column prop="expired_renewed" align="center" label="到期未续签" width="120">
											<template slot-scope="scope">
												<span :class="'green'" v-show="scope.row.expired_renewed < -90 ">未到期</span>
												<span :class="'orange'" v-show="scope.row.expired_renewed > -90 && scope.row.expired_renewed < 0 ">即将到期</span>
												<span :class="'red'" v-show="scope.row.expired_renewed >= 0 ">已到期，请续签。</span>
											</template>
										</el-table-column>
										<!-- <el-table-column prop="printed_contract_returned" align="center"
											label="已用印合同未返回" width="150">
										</el-table-column>
										<el-table-column prop="entry_contract_signed" align="center" label="进场合同未签"
											width="150">
										</el-table-column> -->
										<el-table-column prop="notes" align="center" label="备注">
										</el-table-column>
										<!-- <el-table-column prop="annex" align="center" label="附件">
										</el-table-column> -->
										<el-table-column align="center" label="操作" fixed="right" width="120">
											<template slot-scope="scope">
												<img src="../../../assets/编辑.png" @click="UpdateFrom(scope.row)">
												<img src="../../../assets/删除.png" @click="Del(scope.row.id)"
													style="margin-left: 10px" />
											</template>
										</el-table-column>
									</el-table>
								</el-row>

								<el-row style="margin-top: 10px; text-align: center;">
									<el-pagination background @current-change="handleCurrentChange"
										:page-size="page_size" layout=" prev, pager, next, jumper" :total="total">
									</el-pagination>
								</el-row>
							</div>
						</el-col>
					</el-row>
				</div>
			</el-row>

			<!-- 详情 -->
			<div>
				<el-dialog :title="from.id == null || from.id == '' ? '添加项目合同' : '修改项目合同'" :visible.sync="dialogVisible"
					width="60%" :close-on-click-modal="false" :center="true">

					<el-form :model="from" :rules="rules" ref="from" style="" label-width="130px">
						<el-row>
							<el-col :span="12">
								<el-form-item label="合同编码" prop="contract_code">
									<el-input v-model="from.contract_code" style="width: 80%;"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="合同名称" prop="contract_name">
									<el-input v-model="from.contract_name" style="width: 80%;"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="系列" prop="series_id">
									<el-select v-model="from.series_id" clearable
										style="width:80%;">
										<el-option v-for="series in seriesList" :key="series.id" :label="series.data"
											:value="series.id">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="业务板块" prop="andInnovation_id">
									<el-select v-model="from.andInnovation_id" clearable
										style="width:80%;">
										<el-option v-for="sector in sectorList" :key="sector.id" :label="sector.data"
											:value="sector.id">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="甲方" prop="first_party">
									<el-input v-model="from.first_party" style="width: 80%;"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="乙方" prop="second_party">
									<el-input v-model="from.second_party" style="width: 80%;"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="开始时间" prop="time_on">
									<el-date-picker type="date" value-format="yyyy-MM-dd"
										v-model="from.time_on" style="width:80%"></el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="结束时间" prop="time_end">
									<el-date-picker type="date" value-format="yyyy-MM-dd"
										v-model="from.time_end" style="width:80%"></el-date-picker>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="单价" prop="unit_price">
									<el-input v-model="from.unit_price" style="width: 80%;" type="number"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="数量" prop="number">
									<el-input v-model="from.number" style="width: 80%;" type="number"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="月合计" prop="monthly_total">
									<el-input v-model="from.monthly_total" style="width: 80%;"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="年合计" prop="annual_total">
									<el-input v-model="from.annual_total" style="width: 80%;"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="页码数" prop="page_number">
									<el-input v-model="from.page_number" style="width: 80%;"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="合同约定账期" prop="contractual_accounting_period">
									<el-input v-model="from.contractual_accounting_period" style="width: 80%;"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="履约金" prop="performance_bond">
									<el-input v-model="from.performance_bond" style="width: 80%;"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								
								<el-form-item label="备注" prop="name">
									<el-input v-model="from.notes" style="width: 80%;"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<!-- <el-row>
							<el-col :span="12">
								<el-form-item label="已用印合同未返回" prop="name">
									<el-input v-model="from.printed_contract_returned" style="width: 80%;"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="进场合同未签" prop="name">
									<el-input v-model="from.entry_contract_signed" style="width: 80%;"></el-input>
								</el-form-item>
							</el-col>
						</el-row> -->

						<!-- <el-row>
							<el-col :span="12">
								<el-form-item label="项目名称" prop="name">
									<el-input v-model="from.entry_name" style="width: 80%;"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
							</el-col>
						</el-row> -->
						<el-row>
							<el-col :span="12">
								<el-form-item label="附件" prop="name">
									<el-upload class="upload-demo" :action="$globals.http + '/file/upload'"
										:on-preview="handlePreview" :on-remove="handleRemove" :on-success="uploadFujian"
										:before-remove="beforeRemove" multiple :on-exceed="handleExceed"
										:file-list="fileList" :v-model="from.annex">
										<el-button type="goon" style="font-size:10px;width:100px">上传附件</el-button>
									</el-upload>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<!-- <el-form-item label="到期未续签" prop="name">
									<el-input v-model="from.expired_renewed" style="width: 80%;"></el-input>
								</el-form-item> -->
							</el-col>
						</el-row>
						
						<el-form-item style="text-align: center;margin-left:-10%">
							<el-button type="primary" @click="Add" v-show="from.id == null || from.id == ''"
								style="width: 15%; background-color: #006E4B; border: 1px solid #006E4B;">保存</el-button>
							<el-button type="primary" @click="Update" v-show="from.id != null && from.id != ''"
								style="width: 15%; background-color: #006E4B; border: 1px solid #006E4B;">修改</el-button>
						</el-form-item>
					</el-form>
				</el-dialog>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				//列表相关
				page_num: 1,
				page_size: 10,
				total: 0,
				tableData: [],
				List: [],

				//条件
				condition: {
					contract_name: "",
				},

				//复选框ids
				ids: [],

				//页面相关
				dialogVisible: false,
				editShow: false,

				//表单数据
				from: {
					id: "",
					contract_code:"",
					entry_name:"",
					contract_name:"",
					series_id:"",
					andInnovation_id:"",
					industry_andInnovation:"",
					first_party:"",
					second_party:"",
					time_on:"",
					time_end:"",
					unit_price:"",
					number:"",
					monthly_total:"",
					annual_total:"",
					page_number:"",
					contractual_accounting_period:"",
					performance_bond:"",
					// expired_renewed:"",
					// printed_contract_returned:"",
					// entry_contract_signed:"",
					notes:"",
					annex:"",
				},
				seriesList:[],
				sectorList:[],
				

				//表单验证
				rules: {
					contract_code: [
						{ required: true, message: '请输入合同编码', trigger: 'blur' },
					],
					contract_name: [
						{ required: true, message: '请输入合同名称', trigger: 'blur' },
					],
					series_id: [
						{ required: true, message: '请选择系列', trigger: 'blur' },
					],
					andInnovation_id: [
						{ required: true, message: '请选择业务板块', trigger: 'blur' },
					],
					first_party: [
						{ required: true, message: '请输入甲方', trigger: 'blur' },
					],
					second_party: [
						{ required: true, message: '请输入乙方', trigger: 'blur' },
					],
					time_on: [
						{ required: true, message: '请选择开始时间', trigger: 'blur' },
					],
					time_end: [
						{ required: true, message: '请选择结束时间', trigger: 'blur' },
					],
					unit_price: [
						{ required: true, message: '请输入单价', trigger: 'blur' },
					],
					number: [
						{ required: true, message: '请输入数量', trigger: 'blur' },
					],
					monthly_total: [
						{ required: true, message: '请输入月合计', trigger: 'blur' },
					],
					annual_total: [
						{ required: true, message: '请输入年合计', trigger: 'blur' },
					],
					page_number: [
						{ required: true, message: '请输入页码数', trigger: 'blur' },
					],
					contractual_accounting_period: [
						{ required: true, message: '请输入合同约定账期', trigger: 'blur' },
					],
					performance_bond: [
						{ required: true, message: '请输入履约金', trigger: 'blur' },
					],
				}
			}
		},
		methods: {
			// 全选
			handleSelectionChange(val) {
				this.ids = [];
				e.forEach(item => {
					this.ids.push(item.id);
				})
			},
			//添加页面
			AddFrom() {
				this.from = {};
				this.dialogVisible = true;
			},
			//添加操作
			Add() {
				this.$refs["from"].validate(async (valid) => {
					if (valid) {
						var url = "contract/add";
						var data = await this.$globals.AxiosPost(url, this.from);
						if (data === "-2000") {
							this.$message.error("服务器未响应！请稍后重试");
						} else {
							var code = data.code;
							var data = data.data;
							if (code === '200') {
								this.$message.success(data);
								this.dialogVisible = false;
								this.from = {};
								this.Find();
							} else {
								this.$message.warning(data);
							}
						}
					}
				});
			},
			//编辑页面
			UpdateFrom(e) {
				this.from = e;
				this.dialogVisible = true;
			},
			//编辑操作
			Update() {
				this.$refs["from"].validate(async (valid) => {
					if (valid) {
						var url = "contract/update";
						var data = await this.$globals.AxiosPost(url, this.from);
						if (data === "-2000") {
							this.$message.error("服务器未响应！请稍后重试");
						} else {
							var code = data.code;
							var data = data.data;
							if (code === '200') {
								this.$message.success(data);
								this.dialogVisible = false;
								this.from = {};
								this.Find();
							} else {
								this.$message.warning(data);
							}
						}
					}
				});
			},
			//删除
			async Del(e) {
				var url = "contract/del";
				var record = {
					ids: [e]
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.dialogVisible = false;
						this.from = {};
						this.Find();
					} else {
						this.$message.warning(data);
					}
				}
			},
			//分页
			handleCurrentChange(val) {
				this.page_num = val;
				this.Find();
			},
			//查询
			async Find() {
				var url = "contract/getList";
				var record = {
					page_num: this.page_num,
					page_size: this.page_size,
					contract_name: this.condition.contract_name
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
					} else {
						this.$message.warning("请求失败！请稍后重试");
					}
				}
			},
			uploadFujian(res, file) {
				this.from.annex = res.data.fileUrl;
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
		},
		async created() {
			this.Find();
			var seriesList = await this.$globals.AxiosPost("/dictionaries/selectFind", {
				data_grouping: "business_series"
			});
			this.seriesList = seriesList.data;
			var sectorList = await this.$globals.AxiosPost("/dictionaries/selectFind", {
				data_grouping: "business_sector"
			});
			this.sectorList = sectorList.data;
		}
	}
</script>

<style>
	.el-button--goon:focus,
	.el-button--goon:hover {
		background: #006E4B;
		color: #fff;
	}

	.red {
		color: #DA0618;
	}

	.orange {
		color: orange;
	}

	.green {
		color: #50C58F;
	}

	.el-button--goon {
		color: #FFF;
		background-color: #006E4B;
		width: 85px;
	}

	.el-table .warning-row {
		background: oldlace;
	}

	.el-table .success-row {
		background: #f0f9eb;
	}
</style>



// WEBPACK FOOTER //
// Xmht.vue?270800e6